'use client';

import { motion } from 'motion/react';
import Container from '@/components/layout/Container';
import Flex from '@/components/layout/Flex';
import Section from '@/components/layout/Section';
import Spacer from '@/components/shared/Spacer';
import { formatForLabel } from '@/lib/utils';
import { useViewport } from '@/components/providers/ViewportProvider';
import { useHeader } from '@/components/project/Header';
import Button from '@/components/ui/Button';
import Divider from '@/components/shared/Divider';
import LogoButton from '@/components/project/LogoButton';
import { TypographySmall } from '@/components/shared/Typography';
import { CTAS, FOOTER_SECTION_ID, URLS_LIST } from './consts';

function Footer() {
  const { headerHeight } = useHeader();
  const { isMobileMode } = useViewport();

  return (
    <motion.footer
      id={FOOTER_SECTION_ID}
      className="bg-card-secondary"
      style={isMobileMode ? { paddingBottom: headerHeight } : {}}
    >
      <Section.Base id={FOOTER_SECTION_ID}>
        <Container id={FOOTER_SECTION_ID} maxWidth="max-w-5xl">
          <Flex justify="center" items="center">
            <LogoButton presetRatio="square" />
          </Flex>

          <Spacer size="h-4" />

          {/* Page List */}
          <Flex
            direction="column"
            justify="center"
            items="center"
            responsive={{ md: 'md:flex-row md:flex-wrap' }}
            className="max-w-2xl"
          >
            {URLS_LIST.map(({ label, href, variant }) => (
              <Button.Icon
                key={label}
                label={formatForLabel(label, false)}
                variant={variant}
                href={href}
                className="w-fit"
              />
            ))}
          </Flex>

          <Spacer size="h-4" />

          {/* CTAs */}
          <Flex
            direction="column"
            justify="center"
            items="center"
            gap="gap-4"
            responsive={{ md: 'md:flex-row' }}
            className="max-w-2xl"
          >
            {CTAS.map(({ label, ...cta }) => (
              <Button.Icon key={label} label={label} {...cta} />
            ))}
          </Flex>

          <Divider />

          <Flex fill={true} direction="column" className="w-full">
            <Flex fill={true} justify="end" className="flex-1">
              <Button.Icon
                label=""
                variant="outline"
                icon="instagram"
                className="rounded-full"
              />
              <Button.Icon
                label=""
                variant="outline"
                icon="facebook"
                className="rounded-full"
              />
            </Flex>

            <Flex fill={true} justify="end" className="flex-1">
              <TypographySmall className="text-white">
                SLP CUSTOM BUILT, LLC. ALL RIGHTS RESERVED | DESIGNED & CRAFTED
                BY KEENAN JOHNS
              </TypographySmall>
            </Flex>
          </Flex>

          {/* Icons */}
        </Container>
      </Section.Base>
    </motion.footer>
  );
}

export default Footer;
